 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin~autoCollectItem~collections~domains~domainsManagement~insights~settings":"admin~autoCollectItem~collections~domains~domainsManagement~insights~settings","admin~insights~moderation~settings":"admin~insights~moderation~settings","admin~settings":"admin~settings","admin":"admin","settings":"settings","dashboard~insights~user":"dashboard~insights~user","insights":"insights","autoCollectItem~collections~gallery~starred":"autoCollectItem~collections~gallery~starred","autoCollectItem":"autoCollectItem","collections":"collections","domains":"domains","domainsManagement":"domainsManagement","moderation":"moderation","autoCollect":"autoCollect","gallery":"gallery","starred":"starred","autoCollectSettings":"autoCollectSettings","browser":"browser","changelog":"changelog","dashboard":"dashboard","user":"user","discordAuthorize":"discordAuthorize","domainsDonate":"domainsDonate","experiments":"experiments","flowinityAuthorize":"flowinityAuthorize","home":"home","item":"item","legalPrivacy":"legalPrivacy","legalTerms":"legalTerms","pageItem":"pageItem","passwordResetConfirm":"passwordResetConfirm","passwordResetSent":"passwordResetSent","pastes":"pastes","pastesCreate":"pastesCreate","plansBilling":"plansBilling","register":"register","slideshow":"slideshow","users":"users"}[chunkId]||chunkId) + "." + {"admin~autoCollectItem~collections~domains~domainsManagement~insights~settings":"b9770b15","admin~insights~moderation~settings":"137d4ac4","admin~settings":"abfd5b58","admin":"f75fa4be","settings":"64f4b3f4","dashboard~insights~user":"98da2c2d","insights":"a0285b9f","autoCollectItem~collections~gallery~starred":"ac682d74","autoCollectItem":"8ef96af7","collections":"0129ea1f","domains":"eaf0c22a","domainsManagement":"82c79d3b","moderation":"ca3757c4","autoCollect":"056c69b7","gallery":"bb1e940a","starred":"bc89cd28","autoCollectSettings":"6fd7b0e5","browser":"781bb9d1","changelog":"228892e3","dashboard":"fe580360","user":"ca6a6364","discordAuthorize":"ba3e4e32","domainsDonate":"da7e426e","experiments":"f1a2e159","flowinityAuthorize":"7557b980","home":"e9063b40","item":"aee96f5c","legalPrivacy":"1912bd03","legalTerms":"b06470fd","pageItem":"026b413d","passwordResetConfirm":"ba849fca","passwordResetSent":"172543f0","pastes":"72fba8be","pastesCreate":"dbfbc313","plansBilling":"23cafe17","register":"6b49ba0e","slideshow":"801706ab","users":"d350bda5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin~autoCollectItem~collections~domains~domainsManagement~insights~settings":1,"admin~insights~moderation~settings":1,"admin~settings":1,"admin":1,"settings":1,"insights":1,"autoCollectItem~collections~gallery~starred":1,"collections":1,"domains":1,"domainsManagement":1,"moderation":1,"gallery":1,"starred":1,"autoCollectSettings":1,"browser":1,"dashboard":1,"user":1,"experiments":1,"home":1,"pageItem":1,"passwordResetConfirm":1,"passwordResetSent":1,"pastes":1,"register":1,"slideshow":1,"users":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin~autoCollectItem~collections~domains~domainsManagement~insights~settings":"admin~autoCollectItem~collections~domains~domainsManagement~insights~settings","admin~insights~moderation~settings":"admin~insights~moderation~settings","admin~settings":"admin~settings","admin":"admin","settings":"settings","dashboard~insights~user":"dashboard~insights~user","insights":"insights","autoCollectItem~collections~gallery~starred":"autoCollectItem~collections~gallery~starred","autoCollectItem":"autoCollectItem","collections":"collections","domains":"domains","domainsManagement":"domainsManagement","moderation":"moderation","autoCollect":"autoCollect","gallery":"gallery","starred":"starred","autoCollectSettings":"autoCollectSettings","browser":"browser","changelog":"changelog","dashboard":"dashboard","user":"user","discordAuthorize":"discordAuthorize","domainsDonate":"domainsDonate","experiments":"experiments","flowinityAuthorize":"flowinityAuthorize","home":"home","item":"item","legalPrivacy":"legalPrivacy","legalTerms":"legalTerms","pageItem":"pageItem","passwordResetConfirm":"passwordResetConfirm","passwordResetSent":"passwordResetSent","pastes":"pastes","pastesCreate":"pastesCreate","plansBilling":"plansBilling","register":"register","slideshow":"slideshow","users":"users"}[chunkId]||chunkId) + "." + {"admin~autoCollectItem~collections~domains~domainsManagement~insights~settings":"3661bed2","admin~insights~moderation~settings":"e3b8ef03","admin~settings":"464ce8cd","admin":"07a9ed58","settings":"d95a6c1b","dashboard~insights~user":"31d6cfe0","insights":"a6255911","autoCollectItem~collections~gallery~starred":"c99550b4","autoCollectItem":"31d6cfe0","collections":"0ce42a99","domains":"94246184","domainsManagement":"01b8bcf4","moderation":"aa35bca3","autoCollect":"31d6cfe0","gallery":"0ce42a99","starred":"01b8bcf4","autoCollectSettings":"3b711a68","browser":"1ad08695","changelog":"31d6cfe0","dashboard":"0325bb04","user":"f4598581","discordAuthorize":"31d6cfe0","domainsDonate":"31d6cfe0","experiments":"a51eb743","flowinityAuthorize":"31d6cfe0","home":"fbe1b00e","item":"31d6cfe0","legalPrivacy":"31d6cfe0","legalTerms":"31d6cfe0","pageItem":"2f9f93f3","passwordResetConfirm":"2e001121","passwordResetSent":"2e001121","pastes":"07a9ed58","pastesCreate":"31d6cfe0","plansBilling":"31d6cfe0","register":"3f66a0ff","slideshow":"56ab7535","users":"789d0ecc"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
